import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageRequestComponent } from './manage-request.component';

export const manageRequestRoutes: Routes = [
  {
    path: 'manage-request',
    component: ManageRequestComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(manageRequestRoutes)],
  exports: [RouterModule]
})
export class ManageRequestRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request-routing.module.ts